export const DOT = 'dot';
export const COMMA = 'comma';
export const SPACE = 'space';
